/* eslint no-console: 0 */
/* eslint no-restricted-syntax: 0 */
/* eslint @typescript-eslint/no-empty-function: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import { I18n } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { useModal } from '../../../../../presentation/contexts/modal'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import { formatCurrency } from '../../../../../presentation/helpers/helper-price'
import { excerpt } from '../../../../../presentation/helpers/helper-string'
import ITable from '../../../../../presentation/interfaces/table'
import ProductList from '../../../../../presentation/pages/dashboard/menu/products/list'
import CategoryForm from '../../../../../presentation/pages/dashboard/menu/products/list/categoryForm'
import { theme } from '../../../../../presentation/styles/theme'
import { currencyFormat } from '../../../../configs/currency'
import { makeCategory } from '../../../../usecases/categories/load-category-factory'
import { makeProduct } from '../../../../usecases/products/load-product-factory'

const initialData: ITable = {
  headerItems: [
    { label: 'ID', size: 0.5, component: 'Text' },
    { label: 'Imagem', size: 1, component: 'Image' },
    { label: 'Nome', size: 1.5, component: 'Text' },
    { label: 'Valor R$', size: 1, component: 'Text' },
    { label: 'Categoria', size: 1, component: 'Text' },
    { label: 'Destaque', size: 1, component: 'Switch' },
    { label: 'Ativo', size: 1, component: 'Switch' },
    {
      label: 'Ações',
      size: 1,
      component: 'Actions',
      type: 'action',
    },
  ],
  items: [],
  actions: [
    { icon: 'edit', text: 'Editar', color: '#0172CB' },
  ],
  hasCheckbox: true,
}

const defaultFilterItem = { id: '0', name: 'Todos' }

const MakeProductList = () => {
  const { me } = useMe()
  const { setHeader } = usePage()
  const { setText, setIsShowing, setType } = useSnackbar()
  const { updateContent, toggleVisibility } = useModal()
  const { onSetLoading } = useLoading()
  const history = useHistory()
  const [data, setData] = useState<ITable>(initialData)
  const [currentFilterItem, setCurrentFilterItem] = useState(defaultFilterItem)
  const [listUpdated, setListUpdated] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [hasNewCategory, setHasNewCategory] = useState(false)
  const [categories, setCategories] = useState<any>([])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    (async () => {
      onSetLoading(true)
      try {
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeCategory(stablishmentId).load()
        setCategories([defaultFilterItem, ...response.categories])
        if (hasNewCategory) setHasNewCategory((state) => !state)
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me, hasNewCategory])

  const goToEditor = (currentData: any = null) => {
    if (currentData) {
      history.push({
        pathname: '/dashboard/products/editor',
        state: { item: currentData.item },
      })
    } else {
      history.push({
        pathname: '/dashboard/products/editor',
        state: { item: null },
      })
    }
  }

  const toggleSwitchField = async (product: any, field: string) => {
    const current = product[field]
    const formData = new FormData()
    formData.append(field, String(!current))

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeProduct(stablishmentId).patch(product.id, formData)

      setListUpdated((state) => !state)
    } catch (error) {
      console.log(error)
    }
  }

  const categoryDataForm = [{
    items: [
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'Input',
            name: 'name',
            required: true,
            label: 'Nome da categoria',
            title: 'Nome da categoria',
            type: 'text',
            value: '',
            placeholder: 'Ex: Carne',
            validations: 'inputRequired',
          },
          {
            component: 'InputSwitch',
            name: 'isActive',
            label: 'Ativo',
            title: 'Ativo',
            value: '',
            styleContainer: { marginBottom: '10px', width: '30%' },
          },
        ],
      },
      {
        name: 'button',
        component: 'Button',
        title: 'Salvar',
        submittingText: 'Salvando...',
        style: { background: theme.colors.blue, width: '100%', marginTop: '25px' },
      },
    ],
  }]

  const onCategoryDelete = async (id: number): Promise<void> => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeCategory(stablishmentId).delete(id)
      toggleVisibility(false)
      setType('success')
      setText('Deletado com sucesso!')
      setIsShowing(true)
      setHasNewCategory((state) => !state)
    } catch (error: any) {
      const msg = I18n.get(error.name) as string
      setErrorMessage(msg)
      setType('error')
      setText(msg)
      setIsShowing(true)
    }
  }

  const onCategorySubmit = async (items:any): Promise<void> => {
    const { name, isActive } = items

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (items.id) {
        await makeCategory(stablishmentId).patch(items.id, { name, isActive })
      } else {
        await makeCategory(stablishmentId).post({ name, isActive })
      }
      toggleVisibility(false)
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
      setHasNewCategory((state) => !state)
    } catch (error: any) {
      const msg = I18n.get(error.name) as string
      setErrorMessage(msg)
    }
  }

  const handleOpenCategoryForm = (category?: any) => {
    const formDataCategory = {}
    if (category) {
      Object.assign(formDataCategory, category)
    }

    updateContent({
      width: '390px',
      title: category ? 'Editar categoria' : 'Nova categoria',
      component: () => (
        <CategoryForm
          dataForm={categoryDataForm}
          onSubmit={onCategorySubmit}
          onDelete={onCategoryDelete}
          initialFormData={formDataCategory}
          errorMessage={errorMessage}
        />
      ),
    })
    toggleVisibility()
  }

  const formatDataToTable = (response: any) => {
    const productsFormatted: any = []

    response.products.forEach((product: any) => {
      productsFormatted.push({
        item: product,
        datas: [
          { value: product.id, parent: 'ID' },
          { value: product.file.filename, parent: 'Imagem' },
          { value: excerpt(product.name, 37), parent: 'Nome' },
          { value: formatCurrency(product.price, currencyFormat, 'pt-BR'), parent: 'Valor R$' },
          { value: product.category?.name, parent: 'Categoria' },
          {
            value: product.isHighlight,
            parent: 'Destaque',
            handler: () => toggleSwitchField(product, 'isHighlight'),
          },
          {
            value: product.isActive,
            parent: 'Ativo',
            handler: () => toggleSwitchField(product, 'isActive'),
          },
        ],
      })
    })

    const newData = { ...initialData }
    newData.items = productsFormatted
    newData.actions = [
      {
        icon: 'edit',
        handler: goToEditor,
        text: 'Editar',
        color: '#0172CB',
        hoverColor: '#C8E7FF',
      },
    ]

    return newData
  }

  // Get data from api and format to list
  useEffect(() => {
    (
      async () => {
        setHeader({
          title: 'Produtos do cardápio',
          goTo: null,
        })
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeProduct(stablishmentId).load()
        const newData = { ...formatDataToTable(response) }
        setData(newData)
        if (listUpdated) {
          setListUpdated((state) => !state)
        }
      }
    )()
  }, [me, listUpdated])

  const handleFilteredList = () => {
    if (currentFilterItem.name === 'Todos') return data

    const newData = { ...data }
    const filteredItems = newData.items.filter((product: any) => (
      product.item.categoryId === currentFilterItem?.id
    ))
    newData.items = filteredItems
    return newData
  }

  const filteredData = handleFilteredList()

  const handleSearchProduct = async (value: string) => {
    setSearchTerm(String(value))
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeProduct(stablishmentId).load({ term: value })
      const filteredProfile = { ...formatDataToTable(response) }
      setData(filteredProfile)
      handleFilteredList()
    } catch (error) {
      // console.log(error)
    }
  }

  return (
    <ProductList
      dataForm={categoryDataForm}
      onSubmit={onCategorySubmit}
      errorMessage={errorMessage}
      tableData={filteredData}
      goToEditor={goToEditor}
      handleOpenCategoryForm={handleOpenCategoryForm}
      categories={categories}
      setCurrentFilterItem={setCurrentFilterItem}
      currentFilterItem={currentFilterItem}
      setSearchTerm={handleSearchProduct}
      searchTerm={searchTerm}
    />
  )
}

export default MakeProductList
